import React from 'react';
interface LogoProps {
  className?: string;
}
export function Logo({
  className = ''
}: LogoProps) {
  return <div className={`flex items-center ${className}`} data-id="element-169">
      <span className="font-heading font-medium text-2xl tracking-tight text-hubble-text" data-id="element-170">
        Hubble
      </span>
    </div>;
}